// Element id of a car's annual miles cell, the go-to-section target used by the verified annual
// miles notice (#34636).
export const verifiedMilesScrollTargetId = (index) => `cars-${index}-annual-miles`;
